import jobTitleDataService = require("../../core/jobtitles.dataservice");
import { Ng2StateDeclaration } from "@uirouter/angular";
import { JobTitles } from "./jobtitles.component";
import { EditJobTitle } from "./jobtitle.edit.component";
import { JobTitle } from "./jobtitle.component";

/**
 * This state displays all Job Titles
 */
export const jobTitlesState: Ng2StateDeclaration = {
    name: "app.settings.jobtitles",
    url: "/jobtitles",
    views: {
        "main-view@app": {
            component: JobTitles
        }
    },
    resolve: {
        jobTitles: ["jobTitleDataService", (jobTitleDataService: jobTitleDataService.IJobTitleDataService) => {
            return jobTitleDataService.getAll();
        }]
    }
};

/**
 * This state is for creating a new Job Title
 */
export const newJobTitleState: Ng2StateDeclaration = {
    name: "app.settings.jobtitles.new",
    url: "/new",
    views: {
        "main-view@app": {
            component: EditJobTitle
        }
    },
    resolve: {
        jobTitle: function () {
            return <Nema.Crew.Model.JobType>{ Id: -1, Name: "", Active: true, SortTag: "", PersonJobs: null, Activities: null };
        },
        isNew: function () {
            return true;
        }
    }
};

/**
 * This state is for editing a Job Title
 */
export const editJobTitleState: Ng2StateDeclaration = {
    name: "app.settings.jobtitles.edit",
    url: "/{id:int}/edit",
    views: {
        "main-view@app": {
            component: EditJobTitle
        }
    },
    resolve: {
        jobTitle: ["jobTitleDataService", "$stateParams", function (jobTitleDataService: jobTitleDataService.IJobTitleDataService, $stateParams) {
            return jobTitleDataService.get($stateParams.id);
        }],
        isNew: function () {
            return false;
        }
    }
};

/**
 * Job Title Details state
 */
export const jobTitleState: Ng2StateDeclaration = {
    name: "app.settings.jobtitles.detail",
    url: "/{id:int}",
    views: {
        "main-view@app": {
            component: JobTitle
        }
    },
    resolve: {
        jobTitle: ["jobTitleDataService", "$stateParams", function (jobTitleDataService: jobTitleDataService.IJobTitleDataService, $stateParams) {
            return jobTitleDataService.get($stateParams.id);
        }]
    }
};


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./client/app/settings/jobtitles/jobtitles.states.ts